export default __webpack_public_path__ + "static/media/bg-profile-card.b9ce2c1d.png";